import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBar from './SearchBar';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '资讯', to: '/news' },
  { label: '活动', to: '/events' },
  { label: '角色攻略', to: '/characters' },
  { label: '版本更新', to: '/updates' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled && !menuOpen;
  const textColor = transparent ? 'text-background-50' : 'text-foreground-900';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        transparent ? 'bg-transparent' : 'border-b border-background-200 bg-background-50/95 backdrop-blur-md'
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:h-[72px] md:px-6 lg:px-10">
        <Link to="/" className={`flex shrink-0 cursor-pointer items-center gap-2.5 ${textColor}`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-400 to-primary-600">
            <i className="ri-vip-diamond-line text-lg text-background-50"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide">原神资讯站</span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `relative cursor-pointer whitespace-nowrap px-3.5 py-2 text-sm font-label transition-colors ${
                  isActive
                    ? transparent
                      ? 'text-background-50'
                      : 'text-primary-700'
                    : transparent
                      ? 'text-background-50/80 hover:text-background-50'
                      : 'text-foreground-700 hover:text-primary-700'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  <span
                    className={`absolute bottom-0.5 left-1/2 h-0.5 -translate-x-1/2 rounded-full transition-all ${
                      isActive ? 'w-4 bg-accent-500' : 'w-0'
                    }`}
                  />
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden w-56 xl:block">
            <SearchBar />
          </div>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="打开菜单"
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md transition-colors lg:hidden ${
              transparent ? 'text-background-50' : 'text-foreground-800'
            }`}
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="space-y-1 px-4 py-4">
            <SearchBar />
            <nav className="mt-3 flex flex-col">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) =>
                    `cursor-pointer rounded-md px-3 py-2.5 text-sm font-label transition-colors ${
                      isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      ) : null}
    </header>
  );
}